import * as moment from 'moment';

export class Eid {
    public surname: string;
    public firstnames: string;
    // tslint:disable-next-line:variable-name
    public card_number: string;
    // tslint:disable-next-line:variable-name
    public validity_begin_date: string;
    // tslint:disable-next-line:variable-name
    public validity_end_date: string;
    // tslint:disable-next-line:variable-name
    public issuing_municipality: string;
    // tslint:disable-next-line:variable-name
    public national_number: string;
    public nationality: string;
    // tslint:disable-next-line:variable-name
    public location_of_birth: string;
    // tslint:disable-next-line:variable-name
    public date_of_birth: string;
    public gender: string;
    public nobility: string;

    get birthday(): Date {
        const dataOfBirthParts = this.date_of_birth.split(' ');
        const dateMonth = this.national_number.substring(2, 4);
        const dateDay = this.national_number.substring(4, 6);
        const date = dateDay + '/' + dateMonth + '/' + dataOfBirthParts[dataOfBirthParts.length - 1];
        return moment(date, 'DD/MM/YYYY').toDate();
    }

    get firstname(): string {
        return this.firstnames;
    }

    get lastname(): string {
        return this.surname;
    }

    get niss(): string {
        return this.national_number;
    }

    get cardid(): string {
        return this.card_number;
    }
}
